export class SchoolYearSemesterValues {
  selectedYear: number;
  selectedSchoolId: number;
  selectedSemesterId: number;
}
